import { useLayoutEffect, useRef, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import { ROUTES } from './constants/routes';
import { getRegion } from './helpers/getRegion';
import { checkMousePosition } from './helpers/stylesEffects';

import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import { Home } from './pages/Home/Home';
import { YourSixElement } from './pages/YourSixElement/YourSixElement';

import { Acceptation } from './pages/Acceptation/Acceptation';
import { Subscriptions } from './components/Subscriptions/Subscriptions';

import { PrivacyPolicyCOM } from './pages/PrivacyPolicy/PrivacyPolicyCOM';
import { PrivacyPolicyRS } from './pages/PrivacyPolicy/PrivacyPolicyRS';

import { TermsOfServiceCOM } from './pages/TermsOfService/TermsOfServiceCOM';
import { TermsOfServiceRS } from './pages/TermsOfService/TermsOfServiceRS';

import './styles/main.scss';
import { TemporaryNL } from './pages/TemporaryNL/TemporaryNL';
import { SergTestPage } from './pages/SergTestPage/SergTestPage';

function App() {
  const html = document.getElementById('html');
  const domen = getRegion();
  const bgHoverContainer = useRef<HTMLDivElement>(null);
  const [imagesList, setImagesList] = useState<number[]>([]);
  const [isMenuOpened, setMenuOpened] = useState(false);

  const toggleMenu = () => setMenuOpened((prev) => !prev);
  const closeMenu = () => {
    setMenuOpened(false);
  };

  if (html) {
    html.dataset.theme = domen;
  }

  useLayoutEffect(() => {
    if (
      window.location.host === 'sixtix.nl' &&
      window.location.pathname === '/'
    )
      return; // temporary line

    document.addEventListener('mousemove', checkMousePosition);
    document.addEventListener('scroll', () => {
      const menu = document.getElementById('burger-menu');

      if (menu?.getBoundingClientRect().width !== 0) {
        setMenuOpened(false);
      }
    });

    if (bgHoverContainer.current) {
      const bgContainerHeight = bgHoverContainer.current.clientHeight;
      const bgContainerWidth = bgHoverContainer.current.clientWidth;

      const hoverLogoHeight = 110;
      const hoverLogoWidth = 120;

      const totalLogoInRow = Math.ceil(bgContainerWidth / hoverLogoWidth);
      const totalLogoInColumn = Math.ceil(bgContainerHeight / hoverLogoHeight);
      const totalLogos = totalLogoInRow * totalLogoInColumn;

      const images = [];

      for (let i = 1; i <= totalLogos; i++) {
        images.push(i);
      }

      setImagesList(images);
    }
  }, []);

  return (
    <div className="sixtix" id="sixtix">
      <div ref={bgHoverContainer} className="bg-hover-effect">
        {imagesList.map((i) => (
          <img
            src={
              domen === 'rs'
                ? 'images/hover_logo_light.svg'
                : 'images/hover_logo_dark.svg'
            }
            className="bg-logo"
            loading="lazy"
            alt=""
            key={i}
          />
        ))}
      </div>

      {window.location.host === 'sixtix.nl' &&
      window.location.pathname === '/' ? (
        <TemporaryNL />
      ) : (
        <>
          <Header isMenuOpened={isMenuOpened} toggleMenu={toggleMenu} />

          <main className="sixtix__main">
            <Routes>
              <Route
                path={ROUTES.HOME}
                element={
                  <Home isMenuOpened={isMenuOpened} closeMenu={closeMenu} />
                }
              />
              <Route path={ROUTES.SHOP} element={<YourSixElement />} />
              <Route path={ROUTES.MARKETING} element={<YourSixElement />} />
              <Route path={ROUTES.FINANCE} element={<YourSixElement />} />
              <Route path={ROUTES.STATISTICS} element={<YourSixElement />} />
              <Route path={ROUTES.SETTINGS} element={<YourSixElement />} />
              <Route path={ROUTES.DASHBOARD} element={<YourSixElement />} />
              <Route path={ROUTES.ACCEPTION} element={<Acceptation />} />
              {/* <Route path={ROUTES.SUBSCRIPTIONS} element={<Subscriptions />} /> */}
              {(domen === 'com' || domen === 'fr' || domen === 'nl') && (
                <Route path={ROUTES.POLICY} element={<PrivacyPolicyCOM />} />
              )}
              {domen === 'rs' && (
                <Route path={ROUTES.POLICY} element={<PrivacyPolicyRS />} />
              )}
              {(domen === 'com' || domen === 'fr' || domen === 'nl') && (
                <Route path={ROUTES.TERMS} element={<TermsOfServiceCOM />} />
              )}
              {domen === 'rs' && (
                <Route path={ROUTES.TERMS} element={<TermsOfServiceRS />} />
              )}

              <Route path={ROUTES.SERG_TEST_PAGE} element={<SergTestPage />} />
            </Routes>
          </main>

          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
